import QuinceError from './error/quince-error.js';
import initializeAuth from './auth/auth.initializer.js';

const makeFeCommonDataHolder = ()=>{
    let currentEnv;
    let initialized = false;
    let currentFlags = {};
    let locale;
    const initialize = (options)=>{
        currentEnv = options.env;
        initialized = true;
        initializeAuth(currentEnv);
        currentFlags = {
            ...options.flags
        };
        locale = options?.locale ?? 'en-US';
    };
    const throwErrorIfNotInitialized = ()=>{
        if (!initialized) {
            throw new QuinceError({
                name: 'throwErrorIfNotInitialized',
                message: 'Using fe-common before initializing'
            });
        }
    };
    const getEnv = ()=>{
        throwErrorIfNotInitialized();
        return currentEnv;
    };
    const getFlags = ()=>{
        throwErrorIfNotInitialized();
        return currentFlags;
    };
    const getLocale = ()=>{
        throwErrorIfNotInitialized();
        return locale;
    };
    const isFeCommonInitialized = ()=>initialized;
    return {
        isFeCommonInitialized,
        getEnv,
        initialize,
        getFlags,
        getLocale
    };
};
const feCommonDataHolder = globalThis._feCommonDataHolder ?? makeFeCommonDataHolder();
if (!globalThis._feCommonDataHolder) {
    globalThis._feCommonDataHolder = feCommonDataHolder;
}

export { feCommonDataHolder as default };
//# sourceMappingURL=fe-common.initialize.js.map
